import { AppModule } from 'app/module';
import { userDislike } from 'app/userDislike';
import { mediaQueries } from 'util/mediaQueries';
import Template from './template.hbs';
import './styles.scss';

export class DislikeJobModal extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            closeIcon: '.m-dislikeJobModal__closeIcon',
            cancelButton: '.m-dislikeJobModal__cancelButton',
            contentInner: '.m-dislikeJobModal__contentInner',
            overlay: '.m-dislikeJobModal__overlay',
            dislikeCompanyButton: '.m-dislikeJobModal__dislikeCompanyButton',
            dislikeJobButton: '.m-dislikeJobModal__dislikeJobButton',
        };
    }

    getPropsFromDom() {
        return {
            visible: !this.dom.el.classList.contains('m-dislikeJobModal--hide'),
            jobId: this.dom.contentInner.getAttribute('data-job-id'),
            companyId: this.dom.contentInner.getAttribute('data-company-id'),
            companyName: this.dom.contentInner.getAttribute('data-company-name'),
            eventCategory: document.documentElement.getAttribute('data-event-category'),
        };
    }

    domEvents() {
        if (this.dom.dislikeCompanyButton) {
            this.dom.dislikeCompanyButton.addEventListener('click', () => this.dislikeCompanyButton());
        }
        if (this.dom.dislikeJobButton) {
            this.dom.dislikeJobButton.addEventListener('click', () => this.dislikeJobButton());
        }
        if (this.dom.closeIcon) {
            this.dom.closeIcon.addEventListener('click', () => this.closeModalViaClick());
        }
        if (this.dom.cancelButton) {
            this.dom.cancelButton.addEventListener('click', () => this.closeModalViaClick());
        }
        if (this.dom.overlay) {
            this.dom.overlay.addEventListener('click', () => this.closeModalViaClick());
        }
    }

    dislikeCompanyButton() {
        this.closeModal();
        userDislike.dislikeCompany(this.props.companyId, this.props.companyName);
    }

    dislikeJobButton() {
        this.closeModal();
        userDislike.dislikeJob(this.props.jobId, this.props.companyId);
    }

    closeModalViaClick() {
        if (mediaQueries.isMobile()) {
            window.history.back();
        } else {
            this.closeModal();
        }
    }

    closeModal() {
        this.updateProps({ visible: false, errors: false }, true);
        this.events.emit('removeModalStyle');
    }

    openModalViaClick(
        jobId = false,
        companyId = false,
        companyName = false,
        dislikedSameCompanyCount = false,
        dislikedSameCompanyCountIsOne = false,
    ) {
        if (jobId && companyId && companyName && dislikedSameCompanyCount) {
            this.updateProps({
                visible: true, jobId, companyId, companyName, dislikedSameCompanyCount, dislikedSameCompanyCountIsOne,
            }, true);
        } else {
            this.updateProps({ visible: true }, true);
        }
        this.events.emit('addModalStyle');

        if (mediaQueries.isMobile()) {
            this.events.emit('pushStateJobDislikeModal');
        }
    }

    openModal() {
        this.updateProps({ visible: true }, true);
        this.events.emit('addModalStyle');
    }

    isOpen() {
        return this.props.visible;
    }
}
